import { render, staticRenderFns } from "./SubmissionReportLoader.vue?vue&type=template&id=ea8e001c&scoped=true&"
import script from "./SubmissionReportLoader.vue?vue&type=script&lang=js&"
export * from "./SubmissionReportLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8e001c",
  null
  
)

export default component.exports